import styled from 'styled-components';
import { DatePicker } from '@mui/x-date-pickers';
import COLORS from '../../colors';
import dayjs from 'dayjs';

interface DateSelectorProps {
  label: string;
  value: string | undefined;
  minDate?: string | null;
  onChange: (date: string | undefined) => void;
}

const StyledDatePicker = styled(DatePicker)`
  & .MuiSvgIcon-root {
    color: ${COLORS.NEUTRAL_500};
  }
  & .MuiInputBase-input {
    color: ${COLORS.WHITE};
  }
  & .MuiFormHelperText-root {
    color: ${COLORS.NEUTRAL_500};

    &.Mui-error {
      color: ${COLORS.ERROR};
    }

    &.Mui-disabled {
      color: ${COLORS.NEUTRAL_700};
    }
  }
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: ${COLORS.NEUTRAL_500};
    }

    &:hover fieldset {
      border-color: ${COLORS.NEUTRAL_500};
    }

    &.Mui-error .MuiOutlinedInput-notchedOutline {
      color: ${COLORS.ERROR};
      border-color: ${COLORS.ERROR};
      border-width: 3px;
    }
  }
  & .MuiInputLabel-root {
    color: ${COLORS.NEUTRAL_500};

    &.Mui-focused {
      color: ${COLORS.PRIMARY_500};
    }

    &.Mui-error {
      color: ${COLORS.ERROR};
    }

    &.Mui-disabled {
      color: ${COLORS.NEUTRAL_700};
    }
  }
  width: 100%;
`;

const DateSelector = ({
  label,
  value,
  minDate,
  onChange
}: DateSelectorProps) => {
  const handleDateChange = (date: Date | undefined): void => {
    if (!date) {
      onChange(date);
      return;
    }

    if (date?.toString() === 'Invalid Date') {
      onChange(undefined);
      return;
    }

    onChange(date?.toISOString());
  };

  return (
    <>
      <StyledDatePicker
        label={label}
        value={!value ? undefined : dayjs(value)}
        onChange={(newValue: any) => handleDateChange(newValue)}
        format="DD-MM-YYYY"
        slotProps={{
          textField: {
            helperText: 'DD-MM-YYYY'
          }
        }}
        disablePast
        minDate={dayjs(minDate)}
      />
    </>
  );
};

export default DateSelector;
